import { render, staticRenderFns } from "./MentionsView.vue?vue&type=template&id=0b961e47&scoped=true"
var script = {}
import style0 from "./MentionsView.vue?vue&type=style&index=0&id=0b961e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b961e47",
  null
  
)

export default component.exports